import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import s from './Loading.css';

class Loading extends React.Component {
  render() {
    return <div {...this.props} className={`${s.loader}`} />;
  }
}

export default withStyles(s)(Loading);



// WEBPACK FOOTER //
// ./src/components/LoadingIndicator/index.js